module.exports = __webpack_public_path__ + "img/499bc85.jpg";